"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _interfaces = require("../../interfaces");
var _ui = require("../ui");
var _Kind = require("./Kind");
var _ValueWhenTransacted = require("./ValueWhenTransacted");
var _Details = require("./Details");
var _AmountTableData = require("./AmountTableData");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledCard = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 500;\n  border: 1px solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
    typeColor = _ref.typeColor;
  return theme.colors[typeColor !== null && typeColor !== void 0 ? typeColor : 'secondaryShade2'];
});
var TertiaryShadeText = (0, _styledComponents.default)(_ui.P)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiary;
});
var ItemWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var SeparativeLine = (0, _styledComponents.default)(_ui.SeparativeLine)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 22px 0 17px;\n"])));
var StatusTitle = (0, _styledComponents.default)(_ui.StatusTitle)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 16px;\n"])));
var Card = function Card(_ref3) {
  var _transaction$paidAmou, _transaction$paidAmou2, _transaction$paidAmou3, _transaction$paidAmou4;
  var transaction = _ref3.transaction,
    className = _ref3.className,
    statusDotColor = _ref3.statusDotColor,
    fullData = _ref3.fullData,
    fiat = _ref3.fiat,
    onClick = _ref3.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransactionsTable', 'libTransaction', 'libTransfers']),
    t = _useTranslation.t;
  var isWithdraw = transaction.type === _interfaces.TransactionType.WITHDRAWAL;
  var isCryptoInvoice = !!(transaction !== null && transaction !== void 0 && transaction.paidAmount) && !transaction.isFullyPaid && !fiat;
  var typeColor = isCryptoInvoice ? transaction.isOverPaid ? 'warning' : 'danger' : undefined;

  // TODO refactor after adding new kind
  var amount = transaction.paidAmount ? (_transaction$paidAmou = transaction.paidAmount) === null || _transaction$paidAmou === void 0 ? void 0 : _transaction$paidAmou.value : transaction.amount.value;
  var convertedAmount = transaction.paidAmount ? (_transaction$paidAmou2 = transaction.paidAmount) === null || _transaction$paidAmou2 === void 0 ? void 0 : _transaction$paidAmou2.converted : transaction.amount.converted;
  var transactedAmount = transaction.paidAmount ? (_transaction$paidAmou3 = transaction.paidAmount) === null || _transaction$paidAmou3 === void 0 ? void 0 : _transaction$paidAmou3.converted : transaction.transacted.value;
  return /*#__PURE__*/_react.default.createElement(StyledCard, {
    className: className,
    typeColor: typeColor,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pb-0"
  }, /*#__PURE__*/_react.default.createElement(_Kind.Kind, {
    statusDotColor: statusDotColor,
    ticker: transaction.ticker,
    id: transaction.id,
    type: transaction.type,
    dateMillis: transaction.time,
    internal: transaction.internal,
    betweenAccounts: transaction.betweenAccounts,
    fiat: fiat,
    target: transaction.target,
    status: transaction.status,
    overPaid: transaction.isOverPaid,
    paidAmount: (_transaction$paidAmou4 = transaction.paidAmount) === null || _transaction$paidAmou4 === void 0 ? void 0 : _transaction$paidAmou4.value,
    fullyPaid: transaction.isFullyPaid,
    className: "justify-content-center mb-4"
  }), /*#__PURE__*/_react.default.createElement(ItemWrapper, {
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:status'), ":"), /*#__PURE__*/_react.default.createElement(StatusTitle, {
    text: t("libTransaction:status.".concat(transaction.status)),
    dotProps: {
      color: statusDotColor[transaction.status]
    }
  })), /*#__PURE__*/_react.default.createElement(_Details.TransactionsDetailsCard, {
    transaction: transaction,
    fiatWithdraw: fiat && isWithdraw
  })), /*#__PURE__*/_react.default.createElement(SeparativeLine, null), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement(ItemWrapper, null, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:headers.amount'), ":"), /*#__PURE__*/_react.default.createElement(_AmountTableData.AmountTableData, {
    value: amount,
    ticker: transaction.ticker,
    convertedValue: convertedAmount,
    type: transaction.type,
    target: transaction.target,
    exchangePrice: transaction.exchangePrice,
    className: "text-right"
  })), fullData && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, transaction.fee && /*#__PURE__*/_react.default.createElement(ItemWrapper, {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:headers.fee'), ":"), /*#__PURE__*/_react.default.createElement(_AmountTableData.AmountTableData, {
    value: transaction.fee.value,
    ticker: transaction.ticker,
    convertedValue: transaction.fee.converted,
    className: "text-right"
  })), /*#__PURE__*/_react.default.createElement(ItemWrapper, {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:headers.valueWhenTransacted'), ":"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/_react.default.createElement(_ValueWhenTransacted.ValueWhenTransacted, {
    value: transactedAmount,
    price: transaction.transacted.price,
    ticker: transaction.ticker
  }))))));
};
exports.Card = Card;